import { Link } from 'react-router-dom';

export default function OurThoughtsSection() {
  return (
    <section id="our-thoughts" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-accent-light to-accent p-8 lg:p-12 rounded-xl text-center">
            <h3 className="text-2xl font-bold text-navy mb-6">代表・戦略設計責任者のバックグラウンド</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Web制作を始めたきっかけは、<br />
              単なる興味ではありません。
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              長年営業の現場に立つ中で、<br />
              「本当に伝えるべき情報が届いていないWeb」を<br />
              数多く見てきました。
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              どれだけ良い商品やサービスがあっても、<br />
              伝わらなければ存在しないのと同じです。
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              だからこそ私は、<br />
              <strong className="text-cta">"役に立つWeb"をつくりたい</strong>と考えました。
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              作ること自体が目的ではなく、<br />
              成果につながる設計を行うこと。
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              それがY's STUDIOの原点です。
            </p>
          </div>

          {/* ディレクター経歴紹介ボタン */}
          <div className="mt-10 text-center">
            <Link
              to="/director-profile"
              className="inline-flex items-center gap-2 bg-navy hover:bg-navy-dark text-white px-8 py-4 rounded-lg text-lg font-medium transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              ディレクター経歴紹介
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
